<template>
  <div class="container">
    <div class="header">
      <div class="logo">
        <img src="../assets/images/logo-small.png" alt="logo" />
        <span>Your TPR Coin Allocation Platform</span> 
      </div>     
      <div class="login" @click="goToLogin">{{isLogin}}</div>
    </div>
      <div style="display:flex; justifyContent:center" v-if="loading">
        <Spin size="large"></Spin>
      </div>
    <main class="main">
      <div class="title">
        <div class="title__text">
          Convenient  <br /><span>platform </span> for your <span>TPR</span> <br />
          coins allocation
        </div>
        <div class="title__img">
          <img src="../assets/images/bg-screen.png" alt="bg" />
        </div>
      </div>
        
        <router-view />
      
    </main>
     <div class="privacy-text"><a href="https://thepeoplesreserve.com/privacy-policy/" target="_blank">Privacy Policy</a> </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goToLogin() {
      if (!this.loading) {
        if (this.$route.name == 'login') {
          this.$router.push('/')
        }else {
          this.$router.push('/login');
        }
        
      }
    }
  },
  computed: {
    isLogin() {
      if(this.$route.name == 'login') {
        return 'register'
      }else {
        return 'login'
      }
    },
    loading() {
      return this.$store.getters.getGlobalLoading
    }
    
  }
};
</script>

<style lang="scss" scoped>

.container {
  display: flex;
  flex-direction: column;
  background-image: url("../assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 100%;
  min-height: 100vh;
  padding: 0 20px 20px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #edf1f9;
    padding-right: 10px;
    .login {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      display: flex;
      align-items: center;
      text-align: right;
      letter-spacing: 0.01em;
      text-transform: uppercase;
      color: #edf1f9;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    .title {
      width: 50%;
      &__text {
        font-style: normal;
        font-weight: 900;
        font-size: 48px;
        line-height: 60px;
        color: #FFFFFF;
        span {
          color: #fadb08;
        }
      }
    }
  }
}
@media  (max-width: 1440px) {
  .main {
     margin-bottom: 30px;
  }
  .title__img {
    img {
      width: 420px;
    }
  }
}
@media  (max-width: 900px) {
  .logo {
    margin-left: -25px;
  }
  .main {
    align-items: flex-start !important;
    margin-bottom: 30px;
  }
  .title {
    .title__text {
      font-size: 40px !important;
      line-height: 45px !important;
    }
    .title__img {
      img {
        width: 322px ;
      }
    }
  }
  .container-register {
    max-width: 375px !important;
    max-height: 850px !important;
  }
  .container-login {
    max-width: 365px !important;   
  }
}
@media  (max-width: 600px) {
  .logo {
    margin-left: -25px;
    span {
      font-size: 12px;
    }
  }
  .main {
    flex-direction: column;
    align-items: center !important;
    justify-content: flex-start !important;
    margin-bottom: 30px;
  }
  .title {
    width: 100% !important;
    .title__text {
      font-size: 25px !important;
      line-height: 45px !important;
      text-align: center;
      margin-bottom: 20px;
    }
    .title__img {
      display: none;
      img {
        width: 322px ;
      }
    }
  }
  .container-register {
    max-width: 375px !important;
    max-height: 850px !important;
  }
  .container-login {
    max-width: 365px !important;
  }
}
</style>
